export default __webpack_public_path__ + "static/media/SourceSansPro-Regular.560fd875.ttf";